module.exports = __webpack_public_path__ + "img/elastic.46b01cb0.svg";